var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPiiData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-pii-data_svg__clip0_226_8833)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5.75a2.618 2.618 0 011.738.72l5.5 5.5c.2.2.348.449.43.72a.125.125 0 00.154.083.124.124 0 00.054-.032l.33-.33a1 1 0 000-1.413l-5.5-5.5A1.874 1.874 0 005 0H2.5a.997.997 0 00-.9.571.125.125 0 00.113.179H3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11.707a.988.988 0 00.707.293.993.993 0 00.708-.293l1.5-1.5 1.293-1.293a1 1 0 000-1.413l-5.5-5.5A1.875 1.875 0 003.5 1.5H1a1 1 0 00-1 1V5c.016.45.194.878.5 1.207l5.5 5.5zM2.75 3.5a.75.75 0 110 1.5.75.75 0 010-1.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-pii-data_svg__clip0_226_8833"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}
export default SvgIconPiiData;